import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { authSelector } from '../../store/feature/authSlice';
import {
  get_all_accounts,
  storeSelector,
} from '../../store/feature/storeSlice';
import Accounts from '../../components/AllAccounts/Accounts/Accounts';
import CustomLoading from '../../components/Shared/Loading/CustomLoading';
import ReactPaginate from 'react-paginate';
import { useRouter } from 'next/dist/client/router';
import Breadcrumb from '../../components/Shared/Breadcrumb';
import {
  collectionsSelector,
  getCollectionData,
} from '../../store/feature/Collections/CollectionsSlice';
import DynamicAccounts from '../../components/AllAccounts/Accounts/DynamicAccounts';
import { General_text } from '../../constant/Translation/General';
import { Menubar_text } from '../../constant/Translation/Heading';
import InfiniteScroll from 'react-infinite-scroll-component';
import AccountListViewSkeleton from '../../components/Shared/skeletonUI/AccountsListViewSkeleton';

const CollectionAccountsPageLayout2 = () => {
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const dispatch = useDispatch();
  const { isFetching, collection_data } = useSelector(collectionsSelector);

  const loadMoreData = () => {
    if (hasMore) {
      const nextPage = page + 1;
      dispatch(
        getCollectionData({
          bodyParam: {
            id: collection_data?.id,
            data_page: nextPage,
          },
        })
      ).then((res) => {
        if (res.payload?.collections?.length === 0) {
          setHasMore(false);
        } else {
          setPage(nextPage);
        }
      });
    }
  };

  return (
    <div className="flex flex-col gap-8">
      <div className="flex flex-col gap-2">
        {collection_data?.title && (
          <h1 className="title-h1 ">{collection_data?.title}</h1>
        )}
        {collection_data?.description && (
          <p className="description-paragraph ">
            {collection_data?.description}
          </p>
        )}
      </div>
      {collection_data?.accounts?.length > 0 && (
        <InfiniteScroll
          dataLength={collection_data?.accounts?.length || 0}
          next={loadMoreData}
          hasMore={hasMore}
          loader={<AccountListViewSkeleton per_page={15} />}
        >
          <DynamicAccounts
            accounts={collection_data?.accounts}
            isHideFollowButton={true}
          />
        </InfiniteScroll>
      )}
      <div className="">
        <Breadcrumb
          lists={[
            { name: General_text.general.home, link: '/' },
            { name: Menubar_text.more.all_accounts, link: '/a' },
            {
              name: collection_data?.title ?? '',
              link: ``,
            },
          ]}
        />
      </div>
    </div>
  );
};

export default CollectionAccountsPageLayout2;
